module.exports = __webpack_public_path__ + "static/media/potato.44be4e84.png";